<template>
    <div class="detail">
        <el-dialog title="详情" :visible.sync="dialogVisible" width="576px" :before-close="beforeClose">
            <div class="content">
                <el-form ref="form" :model="form" label-width="120px" label-position="left">
                    <el-form-item label="品牌名称：">
                        <p>{{ form.name }}</p>
                    </el-form-item>
                    <el-form-item label="状态：">
                        <p>{{ form.is_open == 0 ? "关闭" : "开启" }}</p>
                    </el-form-item>
                    <el-form-item label="近期操作时间：">
                        <p>{{ form.update_time }}</p>
                    </el-form-item>
                    <div v-for="(item, index) in form.property_list" :key="index">
                        <el-form-item :label="`${labelList[Number(item.type)]}：`">
                            <p>{{ item.title }}</p>
                        </el-form-item>
                        <el-form-item :label="isImage(item.image) ? '图片：' : '文件：'">
                            <el-image v-if="isImage(item.image)" style="width: 200px; height: 200px" :src="item.image" :preview-src-list="[item.image]"> </el-image>
                            <el-link v-else type="primary" @click="down(item.image)" class="lh24">在线查看</el-link>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="" size="medium" @click="beforeClose" plain>关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
export default {
    data() {
        return {
            dialogVisible: false,
            form: {
                name: "",
                is_open: "",
                update_time: "",
                property_list: [],
            },
            // formLoad: false,
            labelList: ["商标", "专利", "ISO证书", "3C证书", "软著", "其他"],
        };
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    mounted() {},
    created() {},
    methods: {
        ...mapActions({
            getBrandDetail: "brand/getBrandDetail",
        }),
        isImage(val) {
            let ext = val.split(".").pop().toLowerCase();
            return ext == "jpg" || ext == "png" || ext == "jpeg";
        },
        down(url) {
            window.open(url);
        },
        getTable(id) {
            // this.formLoad = true;
            let opt = {
                token: this.getToken,
                id: id,
            };
            this.getBrandDetail(opt).then(({ data }) => {
                // this.formLoad = false;
                if (data.code == 1) {
                    this.form = data.data;
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        beforeClose() {
            this.form = {
                name: "",
                is_open: "",
                update_time: "",
                property_list: [],
            };
            this.dialogVisible = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.detail {
    .content {
        min-height: 290px;
        max-height: 500px;
        overflow-y: auto;
        &::-webkit-scrollbar-track-piece {
            background: #d3dce6;
        }

        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background: #99a9bf;
            border-radius: 20px;
        }
    }
}
.lh24 {
    line-height: 24px;
}
</style>